import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { QineticNegotiationApi } from "../../orchestrator-api-client";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitInsurance = createAsyncThunk<void, boolean, ThunkApi>(
  "submitInsurance",
  async (isInsuranceEnabled, { rejectWithValue }) => {
    try {
      await new QineticNegotiationApi().selectInsurance({
        insurance: isInsuranceEnabled,
      });
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Scelta assicurazione",
        description:
          "Non siamo riusciti a selezionare l'assicurazione.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
